import type { AudioPlaybackService } from "../ports";

const audioAdapterRegistry = new Map<string, AudioPlaybackService>();

export const AdapterRegistry = {
	register: (id: string, adapter: AudioPlaybackService) => {
		audioAdapterRegistry.set(id, adapter);
	},
	get: (id: string) => audioAdapterRegistry.get(id),
	unregister: (id: string) => {
		const adapter = audioAdapterRegistry.get(id);
		adapter?.cleanup?.();
		audioAdapterRegistry.delete(id);
	},
	clear: () => {
		for (const [id, adapter] of audioAdapterRegistry) {
			adapter.cleanup?.();
		}
		audioAdapterRegistry.clear();
	},
};
